const heroStats = [
  { value: "12800+", label: "人气连载" },
  { value: "360+", label: "周更作品" },
  { value: "4800万+", label: "追更读者" },
];

export default function Hero() {
  return (
    <section id="home" className="relative flex min-h-[560px] items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20illustration%20of%20a%20lively%20futuristic%20manga%20city%20at%20sunset%2C%20flying%20hero%20silhouettes%20and%20floating%20comic%20panels%20in%20the%20sky%2C%20warm%20papaya%20orange%20and%20coral%20red%20palette%2C%20dramatic%20golden%20light%2C%20cinematic%20atmosphere%2C%20high%20detail%20artistic%20style&width=1600&height=900&seq=hero-fanmugua-01&orientation=landscape"
        alt="番木瓜漫画人气连载平台首屏背景图"
        title="番木瓜漫画 人气连载追更平台"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl px-4 py-24 text-center md:py-32">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/15 px-4 py-1.5 text-sm font-medium text-white backdrop-blur">
          <i className="ri-flashlight-fill text-secondary-300"></i>
          人气连载一网打尽 · 追更进度实时同步
        </span>
        <h1 className="mt-6 font-heading text-4xl leading-tight text-white md:text-6xl">
          不错过每一话更新
          <span className="block bg-gradient-to-r from-secondary-300 via-primary-300 to-accent-300 bg-clip-text text-transparent">
            热门榜单 · 霸榜作品 · 周更不断
          </span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-white/85 md:text-lg">
          打开番木瓜漫画，追更进度条实时同步每一话更新。热门榜单、霸榜作品、长期连载周更不断，让你一键掌握最新进度，追更不再迷路。
        </p>

        <div className="mx-auto mt-8 flex w-full max-w-xl flex-col items-center gap-3 sm:flex-row">
          <div className="flex w-full items-center gap-3 rounded-full bg-white/95 px-4 py-2.5">
            <i className="ri-search-line text-lg text-foreground-500"></i>
            <input
              type="text"
              placeholder="输入作品名 / 作者 / 题材，例如「星海回响」"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
              aria-label="搜索人气连载"
            />
            <button
              type="button"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </div>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#rank"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            查看热门榜单
          </a>
          <a
            href="#updates"
            className="whitespace-nowrap rounded-full border border-white/40 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-white/15"
          >
            开始追更 <i className="ri-arrow-down-line ml-1"></i>
          </a>
        </div>

        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-4 sm:grid-cols-3">
          {heroStats.map((s) => (
            <div
              key={s.label}
              className="rounded-2xl bg-white/10 px-6 py-4 backdrop-blur"
            >
              <dt className="order-2 text-sm text-white/75">{s.label}</dt>
              <dd className="font-heading text-3xl text-secondary-300">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}